<template>
  <div class="main-dashboard-panel program-list-page">
    <div class="panel-topnav container-fluid">
      <ul class="nav nav-tabs">
        <li>
          <h3 class="page-title">Programs</h3>
        </li>
      </ul>
      <div class="clearfix"></div>
    </div>

    <ProgramListTable
      class="container-fluid pane"
      :organization-id="organizationId"
    />
  </div>
</template>

<script>
import ProgramListTable from './ProgramListTable'
import { getNewAppUrl } from '@/utils/urls'

export default {
  components: { ProgramListTable },
  props: {
    organizationId: {
      type: [String, Number],
      default: '',
    },
  },
  beforeRouteEnter(to, from) {
    window.location.href = getNewAppUrl(to.fullPath, to.params)
  },
}
</script>
